var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"cv-button",class:_vm.buttonClassOpts(),attrs:{"role":"button"}},_vm.inputListeners),[_vm._t("default"),(_vm.icon || _vm.iconHref)?_c('CvSvg',{class:`${_vm.carbonPrefix}--btn__icon`,attrs:{"svg":_vm.icon || _vm.iconHref}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }